export const ACTION_ADD = 'add';
export const ACTION_INIT = 'init';
export const ACTION_REMOVE = 'remove';
export const NAME = 'deferred';
export const UPDATE = 'update';



// WEBPACK FOOTER //
// ./src/store/deferred/const.ts